import { createDemoStep } from '@interhyp/platform-demo';
export const PORTAL_OPEN_OFFER_PAGE = createDemoStep({
    id: 'portal-open-offer-page',
    description: 'Im Angebotsreiter können Sie die erstellten Angebote vergleichen.',
});
